import React from 'react';
import c from 'classnames';

import type { BaseCardProps } from '../types';

const CardTitle: React.FC<Pick<BaseCardProps, 'title' | 'className'>> = (props) => {
  const { title, className } = props;

  const classes = c('Card__title', className);

  return (
    <h3 className={classes}>{title}</h3>
  );
};

export default CardTitle;
